import React, { useEffect, useState } from "react";
import '../../../../assets/css/valuelist.css';
import MainWrapper from "../../../MainWrapper";
import { Link, Navigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back, ic_mode_edit, ic_save } from 'react-icons-kit/md';
import { Table, Form, Button, InputGroup } from 'react-bootstrap';
// import { encrypted } from '../../../../_utils/helpers';
import { connect } from 'react-redux';
import Create from "./models/Create";
import ConfirmDelete from "./models/ConfirmDelete";
import {
	COMPETITORS_REQUEST,
	COMPETITORS_CREATE,
	COMPETITORS_DELETE,
	COMPETITORS_EDIT,
	COMPETITORS_STATE_CHANGE
} from "../../../../_utils/constants/ValueList";
import Loader from "../../../layouts/Loader";
import { toast } from 'react-toastify';

const Competitor = ({
	auth: { auth, isAuthenticated },
	valueList: { valueList, isCreated, isDeleted, isEdited, isLoading },
	fetchCompetitors,
	submitCompetitorsCreate,
	submitCompetitorsDelete,
	submitCompetitorsEdit,
	changeReducerState
}) => {

	// states declarations
	const [createModalOpen, setCreateModalOpen] = useState(false);
	const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
	const [inputVal, setInputVal] = useState('');
	const [deleteCompetitorsId, setDeleteCompetitorsId] = useState('');
	const [editCompetitorsId, setEditCompetitorsId] = useState('');
	const [editCompetitorsName, setEditCompetitorsName] = useState('');

	// use effect function called for authentication
	useEffect(() => {
		if (isAuthenticated) {
			fetchCompetitors(auth[0].token);
		}
	}, [auth, isAuthenticated]);

	// use effect function called after api success
	useEffect(() => {
		if (isCreated === true) {
			toast.success("Competitors Created Successfully.");
			fetchCompetitors(auth[0].token);
			changeReducerState();
		}
		if (isDeleted === true) {
			toast.success("Competitors Deleted Successfully.");
			fetchCompetitors(auth[0].token);
			changeReducerState();
		}
		if (isEdited === true) {
			toast.success("Competitors Data Updated Successfully.");
			fetchCompetitors(auth[0].token);
			changeReducerState();
		}
	}, [isCreated, isDeleted, isEdited]);

	// function to open create modal
	const showCreateModal = () => {
		setCreateModalOpen(true);
	};

	// function to close create modal
	const hideCreateModal = () => {
		setCreateModalOpen(false);
	};

	// function called for input value change of create modal
	const handleCreateModalChange = (e) => {
		setInputVal(e.target.value);
	}

	// function called for create age demographic create api
	const handleCreateModalSubmit = (e) => {
		e.preventDefault();
		if (inputVal === '') {
			toast.error("Competitors name cannot be empty.");
		} else {
			submitCompetitorsCreate({
				"data": {
					"Competitor": inputVal,
					"CreatedBy": auth[0].userId
				},
				"token": auth[0].token
			});
			hideCreateModal();
		}
	}

	// function to open confirm delete modal
	const showConfirmDeleteModal = (id) => {
		setDeleteCompetitorsId(id);
		setConfirmDeleteModal(true);
	};

	// function to close confirm delete modal
	const hideConfirmDeleteModal = () => {
		setDeleteCompetitorsId('');
		setConfirmDeleteModal(false);
	};

	// function called for delete age demographic delete api
	const handleConfirmDeleteSubmit = () => {
		submitCompetitorsDelete({
			"CompetitorId": deleteCompetitorsId,
			"token": auth[0].token
		});
		hideConfirmDeleteModal();
	}

	// function called on edit icon click
	const handleEditClick = (data) => {
		setEditCompetitorsId(data.competitorId);
		setEditCompetitorsName(data.competitor);
	}

	// function called to save edited data
	const handleEditSaveClick = (data) => {
		if (editCompetitorsName === '') {
			toast.error("Competitors name cannot be empty.");
		} else {
			submitCompetitorsEdit({
				"data": {
					"CompetitorId": data.competitorId,
					"Competitor": editCompetitorsName,
				},
				"token": auth[0].token
			});
			setEditCompetitorsId('');
			setEditCompetitorsName('');
		}
	}

	if (!isAuthenticated) return <Navigate to="/login" />;

	return (
		<MainWrapper>
			<Loader loading={isLoading}>
				<div className="container">

					<div className="sub-header mt-5 mb-3">
						<h2>Competitors</h2>
						<Link className="btn btn-primary me-1" to="/admin"><Icon icon={ic_arrow_back} />Back to Value List</Link>
						<Create
							variant="primary"
							title={`Competitors`}
							createModalOpen={createModalOpen}
							showCreateModal={showCreateModal}
							hideCreateModal={hideCreateModal}
							inputVal={inputVal}
							handleCreateModalChange={handleCreateModalChange}
							handleCreateModalSubmit={handleCreateModalSubmit}
						/>
					</div>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>Competitors</th>
								<th width="50">Delete</th>
							</tr>
						</thead>
						<tbody>
							{valueList && valueList.length > 0 ? (
								valueList.map((item, index) => (
									<tr key={index}>
										{editCompetitorsId === item.competitorId ? (
											<td>
												<Form.Group>
													<InputGroup>
														<Form.Control type="text" value={editCompetitorsName} onChange={(evt) => setEditCompetitorsName(evt.target.value)} />
														<Button variant="outline-secondary">
															<Icon size={24} icon={ic_save} onClick={() => handleEditSaveClick(item)} />
														</Button>
													</InputGroup>
												</Form.Group>
											</td>
										) : (
											<td>
												{item.competitor}
												<Icon role="button" className="float-end" size={24} icon={ic_mode_edit} onClick={() => handleEditClick(item)} />
											</td>
										)}
										<td>
											<ConfirmDelete variant="primary" title={`Competitors`} showConfirmDeleteModal={() => showConfirmDeleteModal(item.competitorId)} hideConfirmDeleteModal={hideConfirmDeleteModal} handleConfirmDeleteSubmit={handleConfirmDeleteSubmit} confirmDeleteModal={confirmDeleteModal} />
										</td>
									</tr>
								))
							) : (
								<tr>
									<td colSpan={2}>
										No Data Found.
									</td>
								</tr>
							)}
						</tbody>
					</Table>
				</div>
			</Loader>
		</MainWrapper>
	);
}

const mapStateToProps = ({ auth, valueList }) => {
	return {
		auth,
		valueList
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		fetchCompetitors: (token) => dispatch({ type: COMPETITORS_REQUEST, token }),
		submitCompetitorsCreate: (data) => dispatch({ type: COMPETITORS_CREATE, payload: data }),
		submitCompetitorsDelete: (data) => dispatch({ type: COMPETITORS_DELETE, payload: data }),
		submitCompetitorsEdit: (data) => dispatch({ type: COMPETITORS_EDIT, payload: data }),
		changeReducerState: () => dispatch({ type: COMPETITORS_STATE_CHANGE })
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(Competitor);